export const COOKIE_PACKS = [
  { id: "cookies-10", label: "10", cookies: 10, priceCents: 99, limit: 20 },
  { id: "cookies-50", label: "50", cookies: 50, priceCents: 499, limit: 10 },
  { id: "cookies-100", label: "100", cookies: 100, priceCents: 999, limit: 5 },
  { id: "cookies-150", label: "150", cookies: 150, priceCents: 1499, limit: 5 },
  { id: "cookies-200", label: "200", cookies: 200, priceCents: 1999, limit: 2 },
  { id: "cookies-300", label: "300", cookies: 300, priceCents: 2999, limit: 2 },
];

export const RESCUE_ALISA_LEVELS = [
  {
    level: 1,
    requiredCookies: 0,
    modelLevel: 1,
    free: true,
    guaranteed: [{ gid: 67240064, level: 1, count: 1 }],
    bonus: [
      { gid: 67502338, level: 0, count: 10 },
      { gid: 67240050, level: 1, count: 1 },
      { gid: 67239999, level: 0, count: 1 },
      { gid: 67240142, level: 2, count: 5 },
      { gid: 67240126, level: 5, count: 1 },
    ],
  },
  {
    level: 2,
    requiredCookies: 30,
    modelLevel: 1,
    free: false,
    guaranteed: [{ gid: 402653221, level: 0, count: 1 }],
    bonus: [
      { gid: 67240368, level: 0, count: 10 },
      { gid: 67240220, level: 1, count: 1 },
      { gid: 67240177, level: 0, count: 2 },
      { gid: 67240181, level: 0, count: 1 },
      { gid: 67240195, level: 0, count: 5 },
    ],
  },
  {
    level: 3,
    requiredCookies: 0,
    modelLevel: 1,
    free: true,
    guaranteed: [{ gid: 402653221, level: 0, count: 1 }],
    bonus: [
      { gid: 67502338, level: 0, count: 10 },
      { gid: 67240050, level: 2, count: 1 },
      { gid: 67240224, level: 0, count: 1 },
      { gid: 67436553, level: 0, count: 5 },
      { gid: 67240126, level: 5, count: 2 },
    ],
  },
  {
    level: 4,
    requiredCookies: 50,
    modelLevel: 2,
    free: false,
    guaranteed: [{ gid: 402653221, level: 0, count: 1 }],
    bonus: [
      { gid: 67240369, level: 0, count: 2 },
      { gid: 67239980, level: 8, count: 1 },
      { gid: 67240195, level: 0, count: 8 },
      { gid: 67239974, level: 2, count: 1 },
      { gid: 67240064, level: 1, count: 1 },
    ],
  },
  {
    level: 5,
    requiredCookies: 50,
    modelLevel: 2,
    free: false,
    guaranteed: [{ gid: 67698786, level: 0, count: 5 }],
    bonus: [
      { gid: 67240371, level: 0, count: 5 },
      { gid: 67240179, level: 0, count: 5 },
      { gid: 67240177, level: 2, count: 1 },
      { gid: 67240181, level: 0, count: 2 },
      { gid: 67240064, level: 1, count: 2 },
    ],
  },
  {
    level: 6,
    requiredCookies: 0,
    modelLevel: 2,
    free: true,
    guaranteed: [{ gid: 67240022, level: 2, count: 1 }],
    bonus: [
      { gid: 67240371, level: 0, count: 8 },
      { gid: 67239999, level: 1, count: 1 },
      { gid: 67240008, level: 1, count: 1 },
      { gid: 67240050, level: 2, count: 1 },
      { gid: 67240064, level: 1, count: 3 },
    ],
  },
  {
    level: 7,
    requiredCookies: 80,
    modelLevel: 3,
    free: false,
    guaranteed: [{ gid: 67240422, level: 0, count: 1 }],
    bonus: [
      { gid: 67240371, level: 0, count: 12 },
      { gid: 67240213, level: 0, count: 1 },
      { gid: 67240212, level: 0, count: 1 },
      { gid: 67240191, level: 1, count: 1 },
      { gid: 67240064, level: 2, count: 2 },
    ],
  },
  {
    level: 8,
    requiredCookies: 150,
    modelLevel: 3,
    free: false,
    guaranteed: [{ gid: 67240422, level: 0, count: 1 }],
    bonus: [
      { gid: 67240371, level: 0, count: 16 },
      { gid: 67240216, level: 0, count: 1 },
      { gid: 67240215, level: 0, count: 1 },
      { gid: 67240191, level: 1, count: 2 },
      { gid: 67240064, level: 2, count: 3 },
    ],
  },
  {
    level: 9,
    requiredCookies: 200,
    modelLevel: 4,
    free: false,
    guaranteed: [{ gid: 67240228, level: 0, count: 1 }],
    bonus: [
      { gid: 67240371, level: 0, count: 20 },
      { gid: 67240388, level: 0, count: 20 },
      { gid: 67240390, level: 0, count: 5 },
      { gid: 67240387, level: 2, count: 3 },
      { gid: 67240064, level: 3, count: 1 },
    ],
  },
  {
    level: 10,
    requiredCookies: 300,
    modelLevel: 4,
    free: false,
    guaranteed: [{ gid: 67240422, level: 0, count: 2 }],
    bonus: [
      { gid: 67240371, level: 0, count: 30 },
      { gid: 67240165, level: 0, count: 1 },
      { gid: 67240272, level: 2, count: 5 },
      { gid: 67239999, level: 1, count: 5 },
      { gid: 67240064, level: 3, count: 2 },
    ],
  },
  {
    level: 11,
    requiredCookies: 500,
    modelLevel: 5,
    free: false,
    guaranteed: [{ gid: 67240242, level: 0, count: 1 }],
    bonus: [
      { gid: 67240371, level: 0, count: 40 },
      { gid: 67240164, level: 0, count: 1 },
      { gid: 67240177, level: 2, count: 5 },
      { gid: 67240181, level: 0, count: 10 },
      { gid: 67240064, level: 3, count: 3 },
    ],
  },
  {
    level: 12,
    requiredCookies: 800,
    modelLevel: 5,
    free: false,
    guaranteed: [{ gid: 67240422, level: 0, count: 3 }],
    bonus: [
      { gid: 67240371, level: 0, count: 50 },
      { gid: 67240389, level: 0, count: 10 },
      { gid: 67240390, level: 0, count: 10 },
      { gid: 67240387, level: 2, count: 5 },
      { gid: 67240064, level: 3, count: 4 },
    ],
  },
];

export const FEED_REWARD_POOLS = [
  {
    label: "Pool 1",
    rewards: [
      { gid: 67240402, level: 0, count: 1, weight: 47 },
      { gid: 67239984, level: 0, count: 1, weight: 43 },
      { gid: 67239978, level: 1, count: 1, weight: 42 },
      { gid: 67240246, level: 0, count: 1, weight: 40 },
      { gid: 67240132, level: 0, count: 2, weight: 58 },
      { gid: 67240131, level: 0, count: 3, weight: 59 },
      { gid: 67240128, level: 2, count: 1, weight: 55 },
      { gid: 67240179, level: 0, count: 1, weight: 58 },
      { gid: 67240177, level: 0, count: 1, weight: 60 },
      { gid: 67240371, level: 0, count: 1, weight: 60 },
      { gid: 67240051, level: 0, count: 1, weight: 100 },
      { gid: 67240050, level: 1, count: 1, weight: 60 },
      { gid: 67240110, level: 0, count: 5, weight: 100 },
      { gid: 67240109, level: 0, count: 15, weight: 108 },
      { gid: 67240115, level: 2, count: 15, weight: 110 },
    ],
  },
  {
    label: "Pool 2",
    rewards: [
      { gid: 67240403, level: 0, count: 1, weight: 44 },
      { gid: 67239985, level: 0, count: 1, weight: 41 },
      { gid: 67239979, level: 1, count: 1, weight: 40 },
      { gid: 67240247, level: 0, count: 1, weight: 39 },
      { gid: 67240132, level: 0, count: 2, weight: 58 },
      { gid: 67240131, level: 0, count: 3, weight: 59 },
      { gid: 67240128, level: 2, count: 1, weight: 55 },
      { gid: 67240179, level: 0, count: 1, weight: 58 },
      { gid: 67240177, level: 0, count: 1, weight: 60 },
      { gid: 67240371, level: 0, count: 1, weight: 60 },
      { gid: 67240051, level: 0, count: 1, weight: 100 },
      { gid: 67240050, level: 1, count: 1, weight: 60 },
      { gid: 67240110, level: 0, count: 5, weight: 100 },
      { gid: 67240109, level: 0, count: 15, weight: 108 },
      { gid: 67240115, level: 2, count: 15, weight: 110 },
    ],
  },
];

export const ITEM_LABELS = {
  402653198: "Livehouse",
  402653249: "Vending Machine",
  402653252: "Cafe",
  402653269: "Livehouse Fragment",
  67502338: "Cookie",
  67502339: "Group Buying Star Token",
  67502349: "Starlight Coin",
  67502352: "Elite Rocket Gift",
  67502354: "Heart Gift",
  67502365: "Marble",
  67502366: "Medal",
  67502332: "Drag Racing XP",
  335740930: "Racing Part",
  335740931: "Advanced Racing Part",
  335806466: "Drag Racer",
  134232392: "Drag Racing Supplies",
  134232394: "Drag Racing Supplies",
  1342323941: "Brutal Drag Racing Gift Lv1",
  1342323942: "Brutal Drag Racing Gift Lv2",
  1342323943: "Brutal Drag Racing Gift Lv3",
  1342323944: "Brutal Drag Racing Gift Lv4",
  1342323945: "Brutal Drag Racing Gift Lv5",
  1342323946: "Brutal Drag Racing Gift Lv6",
  1342323947: "Brutal Drag Racing Gift Lv7",
  1342323948: "Brutal Drag Racing Gift Lv8",
  1342323949: "Brutal Drag Racing Gift Lv9",
  67502271: "Challenger Chest Key",
  67174413: "Uranium",
  67240064: "Recruitment Speed Up",
  67502355: "Inflated Hammer",
  67567638: "Mechanical Dragon City",
  68026387: "Mechanical Flying Dragon",
  402653221: "Windmill Fragment",
  67240368: "Titan Equipment Alloy",
  67240371: "Harbor Blueprint",
  67240220: "Golden Pandora",
  67240437: "Officer Equipment Alloy",
  67240438: "Officer Equipment Essence Stone",
  67240439: "Officer Equipment Essence Core",
  67240456: "Warplane Equipment Component",
  67240457: "Warplane Equipment Chip",
  67240458: "Warplane Equipment Core",
  67240177: "Officer XP",
  67240178: "Normal Recruitment Order",
  67240181: "Officer Skill XP Book",
  67240183: "Officer Fragment Chest",
  67240195: "Lucky Chest",
  67240050: "Healing Speed Up",
  67239999: "Fleet Speed Up",
  67240001: "Peace Shield",
  67240142: "Resources Crate",
  67240126: "Commander XP",
  67240224: "Chocolate",
  67436553: "Materials Chest",
  67240369: "Titan Equipment Chip",
  67239980: "Gold Pack",
  67239971: "VIP",
  67239974: "VIP Points",
  67239960: "Gather Bonus",
  67239981: "Commander Skill Reset",
  67239982: "Alliance Bounty Reward",
  67239983: "Elite Teleport",
  67698786: "Saki Fragment",
  67698720: "Major Morgan Fragment",
  67698721: "Loreline Fragment",
  67698730: "Kingsley Fragment",
  67698774: "Aeon Fragment",
  67698812: "Colorful Shuttle Fragment",
  67240179: "Elite Recruitment Order",
  67240022: "Speed Up",
  67240036: "Building Speed Up",
  67240008: "Attack Bonus",
  67240013: "Defense Bonus",
  67240078: "Research Speed Up",
  67240422: "Pick One Purple Decoration",
  67240092: "Oil Crate",
  67240098: "Steel Crate",
  67240104: "Mineral Crate",
  67240110: "Food Crate",
  67240172: "Advanced Troops Expansion",
  67240213: "Blueprint Chest A Rare",
  67240212: "Blueprint Chest A Superior",
  67240118: "Alliance Bounty Reward",
  67240191: "Power Ore Crate",
  67240156: "Alliance Bounty Reward",
  67240182: "Officer Fragment Reward",
  67240216: "Blueprint Chest S Rare",
  67240215: "Blueprint Chest S Superior",
  67240205: "Blueprint Chest Reward",
  67240228: "Fleet Speed Up Lucky Gift",
  67240388: "Warplane Alloy",
  67240390: "Warplane Component",
  67240387: "Warplane Energy Source",
  67240165: "Advanced HP Bonus",
  67240272: "Mutant Meat",
  67240242: "Elite Teleport Lucky Gift",
  67240164: "Advanced Attack Bonus",
  67240389: "Warplane Blueprint",
  67240152: "Lucky Gift",
  67240225: "Record",
  67240226: "Perfume",
  67240249: "Tough Luck",
  67240275: "Empress DNA",
  67240276: "Stored Energy Jar",
  67240277: "Mutagen Source Stone",
  67240278: "Creature Modify Fluid",
  67240280: "Golden Skeleton",
  67240282: "Mutant DNA",
  67240295: "Love Fireworks",
  67436554: "Materials Chest Superior",
  67567626: "Blazing Flowers",
  67698777: "Blueprint A Fragment",
  67698778: "Blueprint S Fragment",
  68026373: "Burning Cherry",
  67960848: "Charming Star",
  67960849: "Guarding Star",
  68419588: "Group Buying Star Alliance Reward",
  68419589: "Group Buying Star Nation Reward",
  68419590: "Group Buying Star Alliance Reward",
  68419591: "Group Buying Star Nation Reward",
  67567644: "Light Fortress",
  68026394: "Light Warship",
  68485126: "Cute Star Bunny",
  68485123: "Elite Rocket",
  68485124: "Mechanical Manta",
  67567645: "Tyrant Mecha",
  67698779: "Zeus Fragment",
  67698789: "Cattie Fragment",
  68026395: "Ruler's Dash",
  68747266: "Victory Dance",
  486539266: "Heart Gift",
  486539267: "Starlight Bouquet",
  486539268: "Starlight Chest",
  486539269: "Starlight Ship",
  486539270: "Starlight Castle",
  67240452: "\"Pick One\" Party Officer Skin",
  67240409: "\"Pick One\" Phantom Officer Skin",
  67240454: "Sky Silhouette Fragment",
  67240417: "Racing Reward Material",
  67240455: "Dye",
  67240513: "Disaster Component Fragment",
  67240469: "Arctic Lion King",
  67240463: "Eternity Core",
  67240464: "Star Master Fragment",
  67240421: "\"Pick One\" Blue Decoration",
  67240477: "Cupid Cat",
  67240502: "Ultimate-Disaster Emperor Fleet",
  67240402: "Rescue Alisa Pool Reward",
  67239984: "Change Name",
  67239978: "Golden Hammer",
  67240246: "Global Conquest Fog",
  67240132: "Troops Expansion",
  67240131: "Troops Expansion",
  67240128: "Troops Expansion",
  67240051: "Healing Speed Up",
  67240109: "Food Crate",
  67240115: "Food Crate",
  67240403: "Rescue Alisa Pool Reward",
  67239985: "Change Name",
  67239979: "Golden Hammer",
  67240247: "Global Conquest Protection",
};

const reward = (gid, level, count) => ({ gid, level, count });

export const BRUTAL_DRAG_RACING_LEVEL_REWARDS = [
  { id: "level-9", target: 9, targetLabel: "Level 9", rewards: [reward(402653249, 0, 1), reward(67240417, 0, 3), reward(67698730, 0, 10), reward(67240179, 0, 3), reward(67240064, 3, 1)] },
  { id: "level-11", target: 11, targetLabel: "Level 11", rewards: [reward(402653249, 0, 2), reward(67240417, 0, 5), reward(67698774, 0, 10), reward(67240437, 0, 25), reward(67240064, 3, 1)] },
  { id: "level-14", target: 14, targetLabel: "Level 14", rewards: [reward(402653252, 0, 1), reward(67240417, 0, 10), reward(67240437, 0, 50), reward(67240276, 0, 10), reward(67240064, 3, 2)] },
  { id: "level-19", target: 19, targetLabel: "Level 19", rewards: [reward(67240417, 0, 15), reward(67240455, 0, 10), reward(67240437, 0, 80), reward(67240388, 0, 10), reward(67240064, 3, 3)] },
  { id: "level-24", target: 24, targetLabel: "Level 24", rewards: [reward(402653252, 0, 2), reward(67240455, 0, 15), reward(67240181, 0, 10), reward(67240177, 2, 10), reward(67240064, 3, 4)] },
  { id: "level-29", target: 29, targetLabel: "Level 29", rewards: [reward(67240417, 0, 20), reward(67240513, 0, 5), reward(67240455, 0, 20), reward(67240437, 0, 100), reward(67240280, 0, 10)] },
  { id: "level-34", target: 34, targetLabel: "Level 34", rewards: [reward(402653252, 0, 3), reward(67240513, 0, 10), reward(67240455, 0, 30), reward(67240368, 0, 60), reward(67240064, 3, 6)] },
  { id: "level-39", target: 39, targetLabel: "Level 39", rewards: [reward(67240469, 0, 1), reward(67240513, 0, 20), reward(67240417, 0, 20), reward(67240388, 0, 50), reward(67240280, 0, 20)] },
  { id: "level-44", target: 44, targetLabel: "Level 44", rewards: [reward(67240469, 0, 1), reward(67240513, 0, 30), reward(67240368, 0, 100), reward(67240177, 2, 20), reward(67240064, 3, 10)] },
  { id: "level-51", target: 51, targetLabel: "Level 51", rewards: [reward(67240469, 0, 1), reward(67240513, 0, 55), reward(67240417, 0, 30), reward(67240439, 0, 15), reward(67240280, 0, 30)] },
];

export const BRUTAL_DRAG_RACING_SCORE_REWARDS = [
  { id: "score-1", score: 60000, rewards: [reward(67240272, 1, 2)] },
  { id: "score-2", score: 100000, rewards: [reward(67240276, 0, 5)] },
  { id: "score-3", score: 160000, rewards: [reward(67240278, 0, 8)] },
  { id: "score-4", score: 250000, rewards: [reward(67240275, 0, 10)] },
  { id: "score-5", score: 350000, rewards: [reward(67240417, 0, 5)] },
];

const BRUTAL_DRAG_RACING_UPGRADE_COSTS = [
  0, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
  1150, 1300, 1450, 1600, 1750, 1950, 2150, 2350, 2550, 2750,
  3000, 3250, 3500, 3750, 4000, 4300, 4600, 5000, 5400, 5900,
  6400, 7000, 7600, 8300, 9000, 9800, 10600, 11500, 12400, 13400,
  14400, 15400, 16400, 17400, 18400, 19400, 20400, 21400, 22400, 23400,
  24400, 25900, 27400, 29400, 33400, 40400, 50400, 65400, 85400, 105400,
  125400,
];

export const BRUTAL_DRAG_RACING_UPGRADE_LEVELS = BRUTAL_DRAG_RACING_UPGRADE_COSTS.map((points, level) => ({
  level,
  points,
  speedMultiplier: level >= 10 ? 1.2 : level >= 5 ? 1.1 : 1,
  materials: [
    reward(335740930, 0, Math.min(6, Math.floor((level + 6) / 10) + 1)),
    reward(335740931, 0, Math.min(6, Math.floor((level + 1) / 10) + 1)),
  ],
}));

export const BRUTAL_DRAG_RACING_SUPPLY_PACKS = [
  { id: "drag-supplies-tier-1", label: "Drag Racing Supplies", gid: 134232394, tier: 1 },
  { id: "drag-supplies-tier-2", label: "Drag Racing Supplies", gid: 134232392, tier: 2 },
  { id: "drag-supplies-tier-3", label: "Drag Racing Supplies", gid: 134232392, tier: 3 },
];

export const BRUTAL_DRAG_RACING_XP_PACKS = [
  { id: "drag-xp-lv1", label: "Lv1", gid: 1342323941, amount: 165, priceCents: 299, dailyLimit: 1, limit: 5 },
  { id: "drag-xp-lv2", label: "Lv2", gid: 1342323942, amount: 330, priceCents: 599, dailyLimit: 1, limit: 5 },
  { id: "drag-xp-lv3", label: "Lv3", gid: 1342323943, amount: 495, priceCents: 999, dailyLimit: 1, limit: 5 },
  { id: "drag-xp-lv4", label: "Lv4", gid: 1342323944, amount: 660, priceCents: 1499, dailyLimit: 1, limit: 5 },
  { id: "drag-xp-lv5", label: "Lv5", gid: 1342323945, amount: 880, priceCents: 1999, dailyLimit: 1, limit: 5 },
  { id: "drag-xp-lv6", label: "Lv6", gid: 1342323946, amount: 1210, priceCents: 2999, dailyLimit: 1, limit: 5 },
  { id: "drag-xp-lv7", label: "Lv7", gid: 1342323947, amount: 1820, priceCents: 3999, dailyLimit: 1, limit: 5 },
  { id: "drag-xp-lv8", label: "Lv8", gid: 1342323948, amount: 2420, priceCents: 5999, dailyLimit: 1, limit: 5 },
  { id: "drag-xp-lv9", label: "Lv9", gid: 1342323949, amount: 3520, priceCents: 9999, dailyLimit: 1, limit: 5 },
];

export const BRUTAL_DRAG_RACING_REWARD_MILESTONES = BRUTAL_DRAG_RACING_LEVEL_REWARDS.map((row) => {
  const internalLevel = row.target;
  const displayLevel = internalLevel + 1;
  const target = BRUTAL_DRAG_RACING_UPGRADE_COSTS[internalLevel] || 0;
  return {
    ...row,
    level: displayLevel,
    target,
    targetLabel: `Level ${displayLevel}`,
    targetPillLabel: `${target.toLocaleString()} XP`,
  };
});

export const ROAD_OF_LEGENDS_MONTHS = [
  {
    id: "2026-05",
    label: "May 2026",
    theme: "Road of Legends",
    premiumPriceCents: 999,
    scoreLabel: "Pass points",
    levels: [
      { level: 1, points: 30, free: [reward(67240064, 0, 2), reward(67240064, 0, 2)], premium: [reward(67240389, 0, 2), reward(67240389, 0, 3)] },
      { level: 2, points: 80, free: [reward(67240437, 0, 10), reward(67240437, 0, 10)], premium: [reward(67240179, 0, 4), reward(67240179, 0, 5)] },
      { level: 3, points: 160, free: [reward(67240178, 0, 2), reward(67240183, 0, 1)], premium: [reward(67567626, 2, 1)] },
      { level: 4, points: 250, free: [reward(67502271, 0, 1)], premium: [reward(67240439, 0, 2), reward(67240439, 0, 2)] },
      { level: 5, points: 335, free: [reward(67240078, 1, 1), reward(67240050, 1, 1)], premium: [reward(67240152, 1, 1)] },
      { level: 6, points: 475, free: [reward(67240249, 0, 1), reward(67240295, 0, 1)], premium: [reward(67240142, 3, 5), reward(67240142, 3, 5)] },
      { level: 7, points: 605, free: [reward(67240098, 2, 3), reward(67240104, 2, 3)], premium: [reward(67240098, 5, 1), reward(67240104, 5, 1)] },
      { level: 8, points: 745, free: [reward(67240126, 5, 2), reward(67240126, 4, 5)], premium: [reward(67240276, 0, 10), reward(67240276, 0, 10)] },
      { level: 9, points: 900, free: [reward(67240191, 5, 1), reward(67240191, 5, 1)], premium: [reward(67240220, 1, 1)] },
      { level: 10, points: 1000, free: [reward(67240437, 0, 15), reward(67240437, 0, 15)], premium: [reward(68026373, 2, 1)] },
      { level: 11, points: 1150, free: [reward(67502271, 0, 1), reward(67240179, 0, 1)], premium: [reward(67502271, 0, 1), reward(67502271, 0, 1)] },
      { level: 12, points: 1300, free: [reward(67502271, 0, 1)], premium: [reward(67240226, 0, 3)] },
      { level: 13, points: 1500, free: [reward(67240064, 2, 1), reward(67240064, 2, 1)], premium: [reward(67240064, 3, 2), reward(67240078, 3, 2)] },
      { level: 14, points: 1600, free: [reward(67436554, 0, 1), reward(67436554, 0, 1)], premium: [reward(67240272, 2, 1)] },
      { level: 15, points: 1800, free: [reward(67502271, 0, 1), reward(67240179, 0, 1)], premium: [reward(67240191, 3, 1)] },
      { level: 16, points: 2000, free: [reward(67240064, 1, 2), reward(67240064, 1, 2)], premium: [reward(67239983, 0, 1), reward(67239981, 0, 1)] },
      { level: 17, points: 2200, free: [reward(67240126, 5, 3), reward(67240126, 4, 6)], premium: [reward(67240126, 6, 4), reward(67240126, 6, 3)] },
      { level: 18, points: 2400, free: [reward(67240220, 0, 1)], premium: [reward(67240220, 1, 2)] },
      { level: 19, points: 2700, free: [reward(67239974, 2, 1), reward(67239971, 2, 1)], premium: [reward(67240213, 0, 10), reward(67240213, 0, 10)] },
      { level: 20, points: 3000, free: [reward(67240064, 2, 1), reward(67240064, 1, 2)], premium: [reward(67502271, 0, 1), reward(67502271, 0, 1)] },
      { level: 21, points: 3300, free: [reward(67240178, 0, 5), reward(67240178, 0, 5)], premium: [reward(67240181, 0, 3), reward(67240181, 0, 3)] },
      { level: 22, points: 3600, free: [reward(67240110, 4, 2), reward(67240110, 3, 2)], premium: [reward(67240177, 2, 3)] },
      { level: 23, points: 3900, free: [reward(67240092, 4, 2), reward(67240092, 3, 2)], premium: [reward(67240142, 3, 5), reward(67240142, 3, 5)] },
      { level: 24, points: 4300, free: [reward(67240064, 2, 1), reward(67240064, 1, 2)], premium: [reward(67240278, 0, 10), reward(67240278, 0, 10)] },
      { level: 25, points: 4600, free: [reward(67239971, 3, 1), reward(67239974, 2, 1)], premium: [reward(67240092, 6, 1)] },
      { level: 26, points: 4900, free: [reward(67240179, 0, 1), reward(67240179, 0, 1)], premium: [reward(67240098, 6, 1)] },
      { level: 27, points: 5300, free: [reward(67240098, 4, 1), reward(67240098, 3, 2)], premium: [reward(67240036, 3, 2), reward(67240064, 3, 3)] },
      { level: 28, points: 5700, free: [reward(67240036, 2, 2), reward(67240064, 2, 2)], premium: [reward(67240104, 6, 1)] },
      { level: 29, points: 6100, free: [reward(67240104, 4, 1), reward(67240104, 3, 2)], premium: [reward(67240126, 6, 4), reward(67240126, 6, 4)] },
      { level: 30, points: 6500, free: [reward(67240022, 2, 3), reward(67240022, 2, 2)], premium: [reward(67240022, 3, 7)] },
    ],
  },
];

export const JOYFUL_MARBLE_PACKS = [
  { id: "marble-12", label: "12", marbles: 12, priceCents: 99 },
  { id: "marble-45", label: "45", marbles: 45, priceCents: 499 },
  { id: "marble-90", label: "90", marbles: 90, priceCents: 999 },
  { id: "marble-180", label: "180", marbles: 180, priceCents: 1999 },
  { id: "marble-450", label: "450", marbles: 450, priceCents: 4999 },
  { id: "marble-900", label: "900", marbles: 900, priceCents: 9999 },
];

export const JOYFUL_MARBLE_DAILY_TASKS = [
  { id: 10001, description: "Log in for a total of $0 days ($1)", target: 1, score: 100, rewards: [reward(67502365, 0, 1), reward(67240064, 0, 3), reward(67240110, 3, 1)] },
  { id: 10002, description: "Explore Ruins $0 times ($1)", target: 2, score: 200, rewards: [reward(67502365, 0, 1), reward(67240064, 0, 3), reward(67240092, 3, 1)] },
  { id: 10003, description: "Kill $0 Zombies ($1)", target: 5, score: 300, rewards: [reward(67502365, 0, 1), reward(67240064, 0, 3), reward(67240092, 3, 1)] },
  { id: 10004, description: "Use $0 minutes of Speed Up ($1)", target: 200, score: 500, rewards: [reward(67502365, 0, 1), reward(67240064, 0, 3), reward(67240098, 3, 1)] },
  { id: 10005, description: "Meld Materials $0 times ($1)", target: 10, score: 500, rewards: [reward(67502365, 0, 1), reward(67240064, 0, 3), reward(67240098, 3, 1)] },
  { id: 10006, description: "Buy $0 Packs ($1)", target: 1, score: 1000, rewards: [reward(67502365, 0, 2), reward(67240064, 0, 3), reward(67240098, 3, 1)] },
];

export const JOYFUL_MARBLE_DROP_SLOTS = [
  { slot: 1, points: 10 },
  { slot: 2, points: 50 },
  { slot: 3, points: 150 },
  { slot: 4, points: 300 },
  { slot: 5, points: 150 },
  { slot: 6, points: 50 },
  { slot: 7, points: 10 },
];

export const JOYFUL_MARBLE_DROP_REWARDS = [
  { id: 1001, board: "Normal", rewards: [reward(67240454, 0, 1)] },
  { id: 1002, board: "Normal", rewards: [reward(67240064, 2, 1)] },
  { id: 1003, board: "Normal", rewards: [reward(67239999, 0, 1)] },
  { id: 1004, board: "Normal", rewards: [reward(67240142, 2, 2)] },
  { id: 1005, board: "Normal", rewards: [reward(67239980, 6, 1)] },
  { id: 1006, board: "Normal", rewards: [reward(67240437, 0, 2)] },
  { id: 1007, board: "Normal", rewards: [reward(67240050, 2, 1)] },
  { id: 1008, board: "Bonus", rewards: [reward(67240454, 0, 1)] },
  { id: 1009, board: "Bonus", rewards: [reward(67239974, 1, 1)] },
  { id: 1010, board: "Bonus", rewards: [reward(67240050, 2, 1)] },
  { id: 1011, board: "Bonus", rewards: [reward(67240181, 0, 1)] },
  { id: 1012, board: "Bonus", rewards: [reward(67240179, 0, 1)] },
  { id: 1013, board: "Bonus", rewards: [reward(67239980, 7, 1)] },
  { id: 1014, board: "Bonus", rewards: [reward(67240225, 0, 1)] },
];

export const JOYFUL_MARBLE_SCORE_MILESTONES = [
  { id: 3001, score: 111, rewards: [reward(67240220, 2, 2), reward(67240126, 6, 1), reward(67240142, 3, 1)] },
  { id: 3002, score: 222, rewards: [reward(67240179, 0, 2), reward(67240437, 0, 10), reward(67240126, 6, 2), reward(67240142, 3, 2)] },
  { id: 3003, score: 333, rewards: [reward(67240022, 2, 4), reward(67240126, 6, 3), reward(67240142, 3, 3)] },
  { id: 3004, score: 666, rewards: [reward(67239999, 1, 4), reward(67240126, 6, 4), reward(67240142, 3, 4)] },
  { id: 3005, score: 888, rewards: [reward(67240064, 3, 1), reward(67240022, 3, 1), reward(67240126, 6, 5), reward(67240142, 3, 5)] },
];

export const JOYFUL_MARBLE_POINT_MILESTONES = [
  { id: 2001, points: 1000, rewards: [reward(67240437, 0, 10), reward(67239980, 7, 2), reward(67240179, 0, 2), reward(67239960, 2, 1), reward(67240022, 2, 5)] },
  { id: 2002, points: 4500, rewards: [reward(67240464, 0, 1), reward(67240177, 2, 10), reward(67240181, 0, 3), reward(67239971, 3, 1), reward(67240022, 2, 6)] },
  { id: 2003, points: 8000, rewards: [reward(67240464, 0, 2), reward(67240177, 2, 10), reward(67240181, 0, 5), reward(67240195, 0, 10), reward(67240022, 2, 8)] },
  { id: 2004, points: 17000, rewards: [reward(67240464, 0, 2), reward(67240225, 0, 5), reward(67240126, 6, 5), reward(67240064, 3, 1), reward(67240022, 3, 5)] },
  { id: 2005, points: 32000, rewards: [reward(67240464, 0, 3), reward(67240179, 0, 20), reward(67240181, 0, 20), reward(67240272, 2, 2), reward(67240022, 3, 5)] },
  { id: 2006, points: 60000, rewards: [reward(67240464, 0, 3), reward(67240368, 0, 100), reward(67240276, 0, 10), reward(67240272, 2, 2), reward(67240022, 3, 6)] },
  { id: 2007, points: 105000, rewards: [reward(67240464, 0, 5), reward(67240369, 0, 10), reward(67240277, 0, 15), reward(67240272, 2, 3), reward(67240022, 3, 7)] },
  { id: 2008, points: 165000, rewards: [reward(67240464, 0, 7), reward(67240368, 0, 150), reward(67240278, 0, 20), reward(67240272, 2, 4), reward(67240022, 3, 8)] },
  { id: 2009, points: 250000, rewards: [reward(67240464, 0, 9), reward(67240369, 0, 20), reward(67240280, 0, 20), reward(67240272, 2, 5), reward(67240022, 3, 9)] },
  { id: 2010, points: 420000, rewards: [reward(67240464, 0, 12), reward(67240371, 0, 200), reward(67240280, 0, 35), reward(67240272, 2, 12), reward(67240022, 3, 20)] },
  { id: 2011, points: 550000, isNew: true, rewards: [reward(402653198, 0, 1), reward(67240464, 0, 14), reward(67240371, 0, 200), reward(67240387, 2, 10), reward(67240390, 0, 20)] },
  { id: 2012, points: 720000, rewards: [reward(67240464, 0, 16), reward(67240368, 0, 300), reward(67240388, 0, 20), reward(67240387, 2, 12), reward(67240390, 0, 25)] },
  { id: 2013, points: 850000, rewards: [reward(67240464, 0, 18), reward(67240369, 0, 30), reward(67240388, 0, 25), reward(67240387, 2, 15), reward(67240390, 0, 30)] },
  { id: 2014, points: 950000, rewards: [reward(67240464, 0, 20), reward(67240371, 0, 300), reward(67240388, 0, 30), reward(67240387, 2, 18), reward(67240390, 0, 35)] },
];

export const JOYFUL_MARBLE_EXCHANGE_STORE = [
  { id: 1, limit: 1, isNew: true, cost: [reward(67502366, 0, 400000)], rewards: [reward(67240502, 0, 1)] },
  { id: 2, limit: 20, cost: [reward(67502366, 0, 19000)], rewards: [reward(67240409, 0, 1)] },
  { id: 3, limit: 10, cost: [reward(67502366, 0, 19000)], rewards: [reward(67240455, 0, 1)] },
  { id: 4, limit: 1, cost: [reward(67502366, 0, 126000)], rewards: [reward(67240172, 0, 1)] },
  { id: 5, limit: 1, cost: [reward(67502366, 0, 314000)], rewards: [reward(68485123, 3, 1)] },
  { id: 6, limit: 200, cost: [reward(67502366, 0, 9000)], rewards: [reward(67240064, 2, 1)] },
  { id: 7, limit: 200, cost: [reward(67502366, 0, 9000)], rewards: [reward(67240050, 2, 1)] },
  { id: 8, limit: 50, cost: [reward(67502366, 0, 15700)], rewards: [reward(67239999, 1, 1)] },
  { id: 9, limit: 50, cost: [reward(67502366, 0, 15700)], rewards: [reward(67240179, 0, 1)] },
  { id: 10, limit: 100, cost: [reward(67502366, 0, 38000)], rewards: [reward(67240064, 3, 1)] },
  { id: 11, limit: 100, cost: [reward(67502366, 0, 38000)], rewards: [reward(67240050, 3, 1)] },
  { id: 12, limit: 50, cost: [reward(67502366, 0, 3000)], rewards: [reward(67240371, 0, 1)] },
  { id: 13, limit: 50, cost: [reward(67502366, 0, 12560)], rewards: [reward(67240177, 1, 1)] },
  { id: 14, limit: 50, cost: [reward(67502366, 0, 15690)], rewards: [reward(67240181, 0, 1)] },
  { id: 15, limit: 500, cost: [reward(67502366, 0, 470)], rewards: [reward(67240064, 0, 1)] },
  { id: 16, limit: 500, cost: [reward(67502366, 0, 470)], rewards: [reward(67240050, 0, 1)] },
  { id: 17, limit: 200, cost: [reward(67502366, 0, 7850)], rewards: [reward(67239999, 0, 1)] },
  { id: 18, limit: 9999, cost: [reward(67502366, 0, 1570)], rewards: [reward(67240195, 0, 1)] },
  { id: 19, limit: 9999, cost: [reward(67502366, 0, 250)], rewards: [reward(67240142, 0, 1)] },
];

export const JOYFUL_MARBLE_HANDBOOK = [
  { points: 100, rewards: [reward(67502365, 0, 1)], alternateRewards: [reward(67502365, 0, 4), reward(67502365, 0, 3), reward(67502365, 0, 3)] },
  { points: 200, rewards: [reward(67240178, 0, 1)], alternateRewards: [reward(67240177, 2, 1), reward(67240179, 0, 1), reward(67240388, 0, 1)] },
  { points: 400, rewards: [reward(67239999, 0, 1)], alternateRewards: [reward(67240050, 2, 1), reward(67239999, 1, 1), reward(67240050, 3, 1)] },
  { points: 600, rewards: [reward(67240050, 0, 10)], alternateRewards: [reward(67240278, 0, 4), reward(67240050, 1, 3), reward(67240064, 2, 3)] },
  { points: 800, rewards: [reward(67502365, 0, 1)], alternateRewards: [reward(67240389, 0, 1), reward(67240437, 0, 3), reward(67240437, 0, 3)] },
  { points: 1100, rewards: [reward(67240050, 1, 1)], alternateRewards: [reward(67240437, 0, 5), reward(67240050, 2, 1), reward(67240064, 2, 1)] },
  { points: 1400, rewards: [reward(67239999, 0, 2)], alternateRewards: [reward(67240438, 0, 2), reward(67239999, 1, 1), reward(67239999, 0, 2)] },
  { points: 1700, rewards: [reward(67240064, 2, 1)], alternateRewards: [reward(67240064, 2, 1), reward(67240126, 6, 1), reward(67240126, 9, 1)] },
  { points: 2100, rewards: [reward(67240220, 1, 1)], alternateRewards: [reward(67240022, 2, 1), reward(67239980, 7, 1), reward(67239980, 7, 1)] },
  { points: 2500, rewards: [reward(67240050, 2, 1)], alternateRewards: [reward(67240064, 2, 1), reward(67240050, 2, 1), reward(67239999, 1, 1)] },
  { points: 2900, rewards: [reward(67240126, 5, 1)], alternateRewards: [reward(67240050, 2, 1), reward(67240437, 0, 2), reward(67240437, 0, 2)] },
  { points: 3500, rewards: [reward(67239999, 0, 2)], alternateRewards: [reward(67239999, 1, 1), reward(67239999, 0, 1), reward(67239999, 0, 1)] },
  { points: 4100, rewards: [reward(67502365, 0, 1)], alternateRewards: [reward(67240050, 2, 2), reward(67240181, 0, 1), reward(67240181, 0, 1)] },
  { points: 4700, rewards: [reward(67240110, 4, 3)], alternateRewards: [reward(67240179, 0, 2), reward(67240177, 2, 1), reward(67240177, 2, 1)] },
  { points: 5300, rewards: [reward(67240064, 2, 1)], alternateRewards: [reward(67240050, 3, 1), reward(67240022, 2, 1), reward(67240022, 2, 1)] },
  { points: 6000, rewards: [reward(67239971, 0, 2)], alternateRewards: [reward(67240437, 0, 5), reward(67240278, 0, 2), reward(67240278, 0, 2)] },
  { points: 6700, rewards: [reward(67240179, 0, 1)], alternateRewards: [reward(67240064, 2, 3), reward(67240389, 0, 1), reward(67240389, 0, 1)] },
  { points: 7400, rewards: [reward(67240022, 2, 1)], alternateRewards: [reward(67240022, 2, 5), reward(67240437, 0, 3), reward(67240437, 0, 3)] },
];

export const JOYFUL_MARBLE_HANDBOOK_GUARANTEED_THRESHOLDS = [
  8100,
  8800,
  9500,
  10200,
  10900,
  11600,
  12300,
  13000,
  13700,
  14400,
  15100,
  15800,
  16500,
  17200,
  17900,
  18600,
  19300,
  20000,
  20700,
];

export const JOYFUL_MARBLE_HANDBOOK_GUARANTEED_POOL = [
  reward(67240437, 0, 1),
  reward(67240178, 0, 1),
  reward(67239999, 0, 1),
  reward(67240050, 0, 1),
  reward(67240437, 0, 2),
  reward(67240050, 1, 1),
  reward(67239999, 1, 1),
  reward(67240064, 2, 1),
  reward(67240220, 1, 1),
  reward(67240050, 2, 1),
  reward(67240126, 5, 1),
  reward(67239971, 0, 1),
  reward(67240142, 1, 1),
  reward(67240220, 0, 1),
];

export const JOYFUL_MARBLE_RANKING_REWARDS = [
  { id: 4001, from: 1, to: 1, rewards: [reward(67567645, 3, 1), reward(67240455, 0, 5), reward(67240179, 0, 5), reward(67240064, 3, 5), reward(67436554, 0, 5)] },
  { id: 4002, from: 2, to: 2, rewards: [reward(67567645, 2, 1), reward(67240455, 0, 3), reward(67240179, 0, 3), reward(67240064, 3, 4), reward(67436554, 0, 4)] },
  { id: 4003, from: 3, to: 3, rewards: [reward(67567645, 1, 1), reward(67240455, 0, 1), reward(67240179, 0, 2), reward(67240064, 3, 3), reward(67436554, 0, 3)] },
  { id: 4004, from: 4, to: 5, rewards: [reward(67239999, 0, 6), reward(67239999, 1, 3), reward(67240064, 3, 2), reward(67436554, 0, 2)] },
  { id: 4005, from: 6, to: 10, rewards: [reward(67239999, 0, 5), reward(67239999, 1, 2), reward(67240064, 2, 5), reward(67436554, 0, 1)] },
  { id: 4006, from: 11, to: 20, rewards: [reward(67239999, 0, 4), reward(67240064, 2, 4), reward(67240220, 1, 4), reward(67240142, 3, 4)] },
  { id: 4007, from: 21, to: 50, rewards: [reward(67239999, 0, 3), reward(67240064, 2, 3), reward(67240220, 1, 3), reward(67240142, 3, 3)] },
  { id: 4008, from: 51, to: 100, rewards: [reward(67239999, 0, 2), reward(67240064, 2, 2), reward(67240220, 1, 2), reward(67240142, 3, 2)] },
];

export const TOY_ADVENTURE_GIFT_LADDER = [
  { id: 1, rewards: [reward(67502355, 0, 10)] },
  { id: 2, rewards: [reward(67502355, 0, 10)] },
  { id: 3, specialReward: true, rewards: [reward(67240179, 0, 3), reward(67239999, 1, 2), reward(67239999, 0, 3), reward(67240022, 2, 3), reward(67240001, 2, 1)] },
  { id: 4, rewards: [reward(67502355, 0, 10)] },
  { id: 5, rewards: [reward(67502355, 0, 10)] },
  { id: 6, rewards: [reward(67502355, 0, 10)] },
  { id: 7, specialReward: true, rewards: [reward(67240179, 0, 5), reward(67239999, 1, 5), reward(67239999, 0, 6), reward(67240022, 2, 5), reward(67240001, 2, 1)] },
  { id: 8, rewards: [reward(67502355, 0, 15)] },
  { id: 9, rewards: [reward(67502355, 0, 15)] },
  { id: 10, rewards: [reward(67502355, 0, 20)] },
  { id: 11, specialReward: true, rewards: [reward(67240179, 0, 10), reward(67239999, 1, 6), reward(67239999, 0, 6), reward(67240022, 2, 8), reward(67240001, 2, 1)] },
  { id: 12, rewards: [reward(67502355, 0, 20)] },
  { id: 13, rewards: [reward(67502355, 0, 20)] },
  { id: 14, rewards: [reward(67502355, 0, 20)] },
  { id: 15, rewards: [reward(67502355, 0, 20)] },
];

export const TOY_ADVENTURE_BOSS_REWARDS = [
  { id: 10001, boss: "Normal Bear", rate: 2.82, max: 30, rare: true, rewards: [reward(67240454, 0, 1)] },
  { id: 10002, boss: "Normal Bear", rate: 7.04, max: 30, rewards: [reward(67240452, 0, 1)] },
  { id: 10003, boss: "Normal Bear", rate: 7.04, rewards: [reward(67240179, 0, 1)] },
  { id: 10004, boss: "Normal Bear", rate: 11.27, rewards: [reward(67240064, 2, 1)] },
  { id: 10005, boss: "Normal Bear", rate: 11.27, rewards: [reward(67240050, 2, 1)] },
  { id: 10006, boss: "Normal Bear", rate: 11.27, rewards: [reward(67240022, 2, 1)] },
  { id: 10007, boss: "Normal Bear", rate: 8.45, rewards: [reward(67240064, 1, 1)] },
  { id: 10008, boss: "Normal Bear", rate: 8.45, rewards: [reward(67240050, 1, 1)] },
  { id: 10009, boss: "Normal Bear", rate: 11.27, rewards: [reward(67240195, 0, 5)] },
  { id: 10010, boss: "Normal Bear", rate: 7.04, rewards: [reward(67239999, 0, 1)] },
  { id: 10011, boss: "Normal Bear", rate: 7.04, rewards: [reward(67239999, 1, 1)] },
  { id: 10012, boss: "Normal Bear", rate: 7.04, rewards: [reward(67240104, 4, 1)] },
  { id: 20001, boss: "Rampage Bear", rate: 2.46, max: 5, rare: true, rewards: [reward(67240454, 0, 3)] },
  { id: 20002, boss: "Rampage Bear", rate: 6.56, max: 20, rare: true, rewards: [reward(67240454, 0, 2)] },
  { id: 20003, boss: "Rampage Bear", rate: 8.2, max: 50, rare: true, rewards: [reward(67240454, 0, 1)] },
  { id: 20004, boss: "Rampage Bear", rate: 8.2, max: 5, rewards: [reward(67240452, 0, 6)] },
  { id: 20005, boss: "Rampage Bear", rate: 9.84, max: 20, rewards: [reward(67240452, 0, 5)] },
  { id: 20006, boss: "Rampage Bear", rate: 12.3, max: 50, rewards: [reward(67240452, 0, 3)] },
  { id: 20007, boss: "Rampage Bear", rate: 4.1, rewards: [reward(67240179, 0, 6)] },
  { id: 20008, boss: "Rampage Bear", rate: 6.56, rewards: [reward(67240064, 3, 2)] },
  { id: 20009, boss: "Rampage Bear", rate: 6.56, rewards: [reward(67240050, 3, 2)] },
  { id: 20010, boss: "Rampage Bear", rate: 1.64, max: 100, rewards: [reward(67240164, 0, 1)] },
  { id: 20011, boss: "Rampage Bear", rate: 1.64, max: 100, rewards: [reward(67240172, 0, 1)] },
  { id: 20012, boss: "Rampage Bear", rate: 6.56, rewards: [reward(67240388, 0, 8)] },
  { id: 20013, boss: "Rampage Bear", rate: 6.56, rewards: [reward(67240390, 0, 8)] },
  { id: 20014, boss: "Rampage Bear", rate: 4.1, rewards: [reward(67240371, 0, 20)] },
  { id: 20015, boss: "Rampage Bear", rate: 6.56, rewards: [reward(67240177, 2, 2)] },
  { id: 20016, boss: "Rampage Bear", rate: 8.2, rewards: [reward(67240181, 0, 3)] },
];

export const TOY_ADVENTURE_DAILY_SCORE_REWARDS = [
  { id: 30001, score: 200, rewards: [reward(67240454, 0, 4), reward(67240179, 0, 10), reward(67240220, 2, 1), reward(67240225, 0, 1), reward(67240001, 2, 1)] },
];

export const TOY_ADVENTURE_RANKING_REWARDS = [
  { id: 1, from: 1, to: 1, rewards: [reward(68485126, 3, 1), reward(67567644, 3, 1), reward(68026394, 3, 1), reward(67240022, 3, 2), reward(67240463, 0, 1)] },
  { id: 2, from: 2, to: 2, rewards: [reward(68485126, 2, 1), reward(67567644, 3, 1), reward(68026394, 3, 1), reward(67240064, 2, 3), reward(67240463, 0, 1)] },
  { id: 3, from: 3, to: 3, rewards: [reward(68485126, 1, 1), reward(67567644, 3, 1), reward(68026394, 3, 1), reward(67240064, 2, 2), reward(67240463, 0, 1)] },
  { id: 4, from: 4, to: 10, rewards: [reward(67567644, 3, 1), reward(68026394, 3, 1), reward(67240036, 2, 3), reward(67240064, 2, 1), reward(67240463, 0, 1)] },
  { id: 5, from: 11, to: 30, rewards: [reward(67567644, 2, 1), reward(67239999, 1, 2), reward(67240036, 2, 2), reward(67240195, 0, 10), reward(67240142, 3, 5)] },
  { id: 6, from: 31, to: 50, rewards: [reward(68026394, 2, 1), reward(67239999, 1, 1), reward(67240036, 2, 1), reward(67240195, 0, 5), reward(67240142, 3, 3)] },
  { id: 7, from: 51, to: 100, rewards: [reward(67240179, 0, 2), reward(67240183, 0, 5), reward(67240177, 1, 1), reward(67240195, 0, 3), reward(67240142, 3, 1)] },
];

export const STARLIGHT_CEREMONY_PACKS = [
  { id: 1, label: "10", amount: 10, priceCents: 99, limit: 999 },
  { id: 2, label: "50", amount: 50, priceCents: 499, limit: 999 },
  { id: 3, label: "100", amount: 100, priceCents: 999, limit: 999 },
  { id: 4, label: "200", amount: 200, priceCents: 1999, limit: 999 },
  { id: 5, label: "500", amount: 500, priceCents: 4999, limit: 999 },
  { id: 6, label: "860", amount: 860, priceCents: 9999, limit: 999, bonus: [reward(67502352, 0, 1)] },
];

function starlightPurchaseMilestone(id, level, knownCumulativeXp, rewards, featured = false) {
  return {
    id,
    target: knownCumulativeXp,
    targetLabel: `Level ${level}`,
    level,
    featured,
    rewards,
  };
}

export const STARLIGHT_CEREMONY_PURCHASE_MILESTONES = [
  starlightPurchaseMilestone(1, 1, 10, [reward(67698779, 0, 5), reward(67239980, 7, 1), reward(67240179, 0, 1), reward(67239960, 2, 1), reward(67240022, 2, 1)]),
  starlightPurchaseMilestone(2, 2, 20, []),
  starlightPurchaseMilestone(3, 5, null, [reward(67240179, 0, 10), reward(67240177, 2, 5), reward(67240181, 0, 5), reward(67239971, 3, 2), reward(67240022, 3, 3)]),
  starlightPurchaseMilestone(4, 9, null, [reward(67698789, 0, 10), reward(67240177, 2, 5), reward(67240181, 0, 5), reward(67240195, 0, 10), reward(67240022, 3, 4)]),
  starlightPurchaseMilestone(5, 13, null, [reward(67240421, 0, 3), reward(67240454, 0, 2), reward(67240126, 6, 5), reward(67240064, 3, 1), reward(67240022, 3, 5)]),
  starlightPurchaseMilestone(6, 17, null, [reward(67240422, 0, 1), reward(67240455, 0, 5), reward(67240179, 0, 15), reward(67240181, 0, 20), reward(67240022, 3, 5)]),
  starlightPurchaseMilestone(7, 22, 1200, [reward(68747266, 1, 1), reward(67240454, 0, 3), reward(67240368, 0, 80), reward(67240368, 0, 100), reward(67240022, 3, 6)], true),
  starlightPurchaseMilestone(8, 27, null, [reward(67240422, 0, 2), reward(67240455, 0, 10), reward(67240369, 0, 10), reward(67240277, 0, 15), reward(67240022, 3, 7)]),
  starlightPurchaseMilestone(9, 32, null, [reward(67240422, 0, 2), reward(67240454, 0, 5), reward(67240368, 0, 120), reward(67240278, 0, 20), reward(67240022, 3, 8)]),
  starlightPurchaseMilestone(10, 37, 4600, [reward(67240477, 0, 1), reward(67240371, 0, 120), reward(67240369, 0, 15), reward(67240280, 0, 20), reward(67240022, 3, 9)], true),
  starlightPurchaseMilestone(11, 42, null, [reward(68026395, 3, 1), reward(67240477, 0, 1), reward(67240371, 0, 150), reward(67240388, 0, 10), reward(67240390, 0, 15)], true),
  starlightPurchaseMilestone(12, 47, null, [reward(67240477, 0, 1), reward(67240422, 0, 4), reward(67240369, 0, 20), reward(67240388, 0, 20), reward(67240390, 0, 25)], true),
  starlightPurchaseMilestone(13, 52, null, [reward(67567645, 3, 1), reward(67240477, 0, 1), reward(67240371, 0, 200), reward(67240388, 0, 30), reward(67240390, 0, 30)], true),
];

export const STARLIGHT_CEREMONY_GIFTS = [
  { id: 486539266, label: "Heart Gift", costItemGid: 67502354, cost: 1, charm: 3 },
  { id: 486539267, label: "Starlight Bouquet", costItemGid: 67502349, cost: 10, charm: 30 },
  { id: 486539268, label: "Starlight Chest", costItemGid: 67502349, cost: 100, charm: 300 },
  { id: 486539269, label: "Starlight Ship", costItemGid: 67502349, cost: 500, charm: 1500 },
  { id: 486539270, label: "Starlight Castle", costItemGid: 67502349, cost: 1000, charm: 3000, featured: true },
  { id: 67502352, label: "Elite Rocket Gift", costItemGid: 67502352, cost: 1, charm: 5000, featured: true },
];

export const STARLIGHT_CEREMONY_SEND_RANK_REWARDS = [
  { id: 1, from: 1, to: 1, rewards: [reward(68485123, 3, 1), reward(67960849, 0, 1), reward(67240280, 0, 25), reward(67240278, 0, 15), reward(67240272, 2, 10)] },
  { id: 2, from: 2, to: 2, rewards: [reward(68485123, 2, 1), reward(67960849, 0, 1), reward(67240280, 0, 20), reward(67240278, 0, 10), reward(67240272, 2, 7)] },
  { id: 3, from: 3, to: 3, rewards: [reward(68485123, 1, 1), reward(67960849, 0, 1), reward(67240280, 0, 15), reward(67240278, 0, 8), reward(67240272, 2, 5)] },
  { id: 4, from: 4, to: 10, rewards: [reward(68485123, 0, 1), reward(67960849, 0, 1), reward(67240280, 0, 8), reward(67240278, 0, 5), reward(67240272, 2, 5)] },
  { id: 5, from: 11, to: 30, rewards: [reward(67960849, 0, 1), reward(67240280, 0, 5), reward(67240278, 0, 5), reward(67240272, 2, 3), reward(67240126, 6, 3)] },
  { id: 6, from: 31, to: 50, rewards: [reward(67240280, 0, 5), reward(67240278, 0, 2), reward(67240272, 1, 3), reward(67240152, 0, 2), reward(67240126, 5, 3)] },
  { id: 7, from: 51, to: 100, rewards: [reward(67240280, 0, 3), reward(67240278, 0, 2), reward(67240272, 0, 2), reward(67240152, 0, 2), reward(67240126, 5, 2)] },
];

export const STARLIGHT_CEREMONY_CHARM_RANK_REWARDS = [
  { id: 1, from: 1, to: 1, rewards: [reward(68485124, 3, 1), reward(67960848, 0, 1), reward(67240278, 0, 15), reward(67240272, 2, 10), reward(67240126, 7, 3)] },
  { id: 2, from: 2, to: 2, rewards: [reward(68485124, 2, 1), reward(67960848, 0, 1), reward(67240278, 0, 10), reward(67240272, 2, 7), reward(67240126, 7, 2)] },
  { id: 3, from: 3, to: 3, rewards: [reward(68485124, 1, 1), reward(67960848, 0, 1), reward(67240278, 0, 8), reward(67240272, 2, 5), reward(67240126, 6, 6)] },
  { id: 4, from: 4, to: 10, rewards: [reward(68485124, 0, 1), reward(67960848, 0, 1), reward(67240022, 3, 5), reward(67240278, 0, 5), reward(67240272, 2, 2)] },
  { id: 5, from: 11, to: 30, rewards: [reward(67960848, 0, 1), reward(67240022, 3, 4), reward(67240278, 0, 3), reward(67240272, 1, 4), reward(67240126, 5, 4)] },
  { id: 6, from: 31, to: 50, rewards: [reward(67240022, 3, 2), reward(67240278, 0, 2), reward(67240272, 1, 1), reward(67240152, 0, 2), reward(67240126, 5, 2)] },
  { id: 7, from: 51, to: 100, rewards: [reward(67240022, 3, 1), reward(67240278, 0, 1), reward(67240272, 1, 1), reward(67240152, 0, 1), reward(67240126, 5, 1)] },
];

function groupBuyingSpendLabel(points) {
  if (!points) return {
    thresholdLabel: "No spend required",
    thresholdDetail: "0 points | 0 gold | $0",
  };
  const gold = points * 10;
  const dollars = Math.ceil(gold / 200);
  return {
    thresholdLabel: `${gold.toLocaleString()} gold (~$${dollars})`,
    thresholdDetail: `${points.toLocaleString()} points`,
  };
}

function groupBuyingDiscountTier(id, threshold, priceCents, offPercent) {
  return {
    id,
    threshold,
    priceCents,
    offPercent,
    ...groupBuyingSpendLabel(threshold),
  };
}

export const GROUP_BUYING_STAR_DISCOUNTS = [
  {
    id: "alliance",
    label: "Alliance Group Buy",
    items: [reward(67240438, 0, 1), reward(68419588, 0, 1), reward(68419590, 0, 1)],
    rows: [
      groupBuyingDiscountTier(1, 0, 9999, 0),
      groupBuyingDiscountTier(2, 8000, 3999, 60),
      groupBuyingDiscountTier(3, 14000, 2999, 70),
      groupBuyingDiscountTier(4, 18000, 1499, 85),
      groupBuyingDiscountTier(5, 22000, 999, 90),
      groupBuyingDiscountTier(6, 30000, 699, 93),
    ],
  },
  {
    id: "nation",
    label: "Nation Group Buy",
    items: [reward(67240437, 0, 1), reward(68419589, 0, 1), reward(68419591, 0, 1)],
    rows: [
      groupBuyingDiscountTier(1, 0, 5999, 0),
      groupBuyingDiscountTier(2, 12000, 2999, 50),
      groupBuyingDiscountTier(3, 20000, 1999, 67),
      groupBuyingDiscountTier(4, 30000, 899, 85),
      groupBuyingDiscountTier(5, 40000, 599, 90),
      groupBuyingDiscountTier(6, 60000, 399, 93),
    ],
  },
];

function groupBuyingMilestone(id, points, rewards) {
  const { thresholdLabel, thresholdDetail } = groupBuyingSpendLabel(points);
  return {
    id,
    target: points,
    targetLabel: thresholdLabel,
    targetDetail: thresholdDetail,
    rewards,
  };
}

export const GROUP_BUYING_STAR_MILESTONES = [
  groupBuyingMilestone(1, 40, [reward(67502339, 0, 1), reward(67240456, 0, 10), reward(67239980, 7, 1), reward(67240458, 0, 2), reward(67240050, 3, 1)]),
  groupBuyingMilestone(2, 120, [reward(67698720, 0, 8), reward(67240456, 0, 15), reward(67239980, 7, 2), reward(67240458, 0, 3), reward(67240050, 3, 1)]),
  groupBuyingMilestone(3, 240, [reward(67698774, 0, 8), reward(67240456, 0, 20), reward(67239980, 8, 2), reward(67240458, 0, 4), reward(67240050, 3, 2)]),
  groupBuyingMilestone(4, 500, [reward(402653269, 0, 1), reward(67240456, 0, 30), reward(67240457, 0, 8), reward(67240458, 0, 6), reward(67240050, 3, 5)]),
  groupBuyingMilestone(5, 1200, [reward(402653269, 0, 1), reward(67240456, 0, 40), reward(67240457, 0, 10), reward(67240458, 0, 8), reward(67240050, 3, 7)]),
  groupBuyingMilestone(6, 2400, [reward(402653269, 0, 1), reward(67240456, 0, 50), reward(67240457, 0, 15), reward(67240458, 0, 10), reward(67240050, 3, 10)]),
  groupBuyingMilestone(7, 4800, [reward(402653269, 0, 3), reward(67698812, 0, 8), reward(67240457, 0, 20), reward(67240458, 0, 12), reward(67240050, 3, 12)]),
  groupBuyingMilestone(8, 8000, [reward(402653269, 0, 4), reward(67698812, 0, 12), reward(67240457, 0, 25), reward(67240458, 0, 15), reward(67240050, 3, 15)]),
  groupBuyingMilestone(9, 12000, [reward(402653198, 0, 1), reward(67698812, 0, 18), reward(67240457, 0, 30), reward(67240458, 0, 20), reward(67240050, 3, 15)]),
  groupBuyingMilestone(10, 16000, [reward(402653198, 0, 1), reward(67698812, 0, 18), reward(67240457, 0, 30), reward(67240458, 0, 20), reward(67240050, 3, 15)]),
];

export const GROUP_BUYING_STAR_REWARD_POOL = [
  { id: 1, label: "Uranium pool", rewards: [reward(67174413, 0, 200000)] },
  { id: 2, label: "Recruitment pool", rewards: [reward(67240179, 0, 30)] },
  { id: 3, label: "Speed up pool", rewards: [reward(67240064, 3, 10)] },
];

function bountyTask(id, star, points, title, content, requirement, timeSeconds, type) {
  return {
    id,
    star,
    points,
    title,
    content,
    requirement,
    timeSeconds,
    type,
  };
}

export const ALLIANCE_BOUNTY_TASKS = [
  bountyTask("star1BountyTask2", 1, 20, "Gather Oil", "Gather $0 Oil", 10000, 18000, "getOil"),
  bountyTask("star3BountyTask7", 3, 120, "Use Fleet Speed Up", "Use $0 Fleet Speed Up", 2, 28800, "useFleetSpeedUp"),
  bountyTask("star3BountyTask5", 3, 100, "Meld Materials", "Meld Materials $0 times", 3, 28800, "meldMaterials"),
  bountyTask("star4BountyTask8", 4, 240, "Use Officer Skill XP", "Use $0 Officer Skill XP", 300, 43200, "useOfficerSkillXPBook"),
  bountyTask("star5BountyTask23", 5, 600, "Use Warplane Equipment Cores", "Use $0 Warplane Equipment Cores", 10, 54000, "useWarplaneCore"),
  bountyTask("star5BountyTask24", 5, 600, "Advanced Antique Exploration", "Antique Advanced Exploration $0 times", 10, 54000, "useAdvancedExploration"),
];

export const ALLIANCE_BOUNTY_LADDER = [
  { level: 1, points: 25, free: [reward(67240064, 0, 5), reward(67240064, 0, 5)], premium: [reward(67240388, 0, 4), reward(67240388, 0, 4)] },
  { level: 2, points: 100, free: [reward(67240126, 4, 5), reward(67240126, 4, 5)], premium: [reward(67240276, 0, 15), reward(67240276, 0, 15)] },
  { level: 3, points: 200, free: [reward(67240110, 3, 1), reward(67240092, 3, 1)], premium: [reward(67240142, 3, 3), reward(67240142, 3, 3)] },
  { level: 4, points: 300, free: [reward(67240050, 1, 1), reward(67240050, 1, 1)], premium: [reward(67240177, 2, 2), reward(67240177, 2, 1)] },
  { level: 5, points: 400, free: [reward(67240098, 2, 1), reward(67240104, 2, 1)], premium: [reward(67698721, 0, 5), reward(67698721, 0, 5)] },
  { level: 6, points: 600, free: [reward(67240036, 1, 1), reward(67240078, 1, 1)], premium: [reward(67240272, 2, 1), reward(67240272, 2, 1)] },
  { level: 7, points: 800, free: [reward(67240064, 1, 1), reward(67240050, 1, 1)], premium: [reward(67240191, 2, 1), reward(67240191, 2, 1)] },
  { level: 8, points: 1000, free: [reward(67436553, 0, 2), reward(67240191, 5, 1)], premium: [reward(67239974, 3, 1), reward(67239974, 3, 1)] },
  { level: 9, points: 1200, free: [reward(67239999, 0, 1), reward(67240118, 0, 1)], premium: [reward(67240098, 6, 1), reward(67240098, 6, 1)] },
  { level: 10, points: 1400, free: [reward(67240008, 0, 1), reward(67240013, 0, 1)], premium: [reward(67240282, 0, 5), reward(67240282, 0, 5)] },
  { level: 11, points: 1600, free: [reward(67240142, 2, 3), reward(67240142, 2, 3)], premium: [reward(67240092, 6, 1), reward(67240092, 6, 1)] },
  { level: 12, points: 1800, free: [reward(67239980, 5, 1), reward(67239980, 5, 1)], premium: [reward(67240064, 3, 1), reward(67240064, 3, 1)] },
  { level: 13, points: 2000, free: [reward(67240183, 0, 3), reward(67240183, 0, 2)], premium: [reward(67240022, 3, 1), reward(67240022, 3, 1)] },
  { level: 14, points: 2500, free: [reward(67240179, 0, 2), reward(67240179, 0, 2)], premium: [reward(67239999, 1, 2), reward(67239999, 1, 2)] },
  { level: 15, points: 3000, free: [reward(67239960, 2, 1), reward(67239982, 0, 1)], premium: [reward(67240126, 6, 3), reward(67240126, 6, 2)] },
  { level: 16, points: 3500, free: [reward(67240215, 0, 5), reward(67240215, 0, 5)], premium: [reward(67240183, 0, 10), reward(67240183, 0, 10)] },
  { level: 17, points: 4000, free: [reward(67436553, 0, 4), reward(67436553, 0, 4)], premium: [reward(67436554, 0, 5), reward(67436554, 0, 5)] },
  { level: 18, points: 4500, free: [reward(67240182, 0, 5), reward(67240182, 0, 5)], premium: [reward(67240156, 0, 1), reward(67240118, 1, 1)] },
  { level: 19, points: 5000, free: [reward(67239999, 1, 1), reward(67239999, 0, 1)], premium: [reward(67240181, 0, 2), reward(67240181, 0, 2)] },
  { level: 20, points: 5800, free: [reward(67240092, 5, 1), reward(67240110, 5, 1)], premium: [reward(67240278, 0, 10), reward(67240278, 0, 10)] },
  { level: 21, points: 6700, free: [reward(67698730, 0, 5), reward(67698730, 0, 5)], premium: [reward(67240022, 3, 1), reward(67240022, 3, 1)] },
  { level: 22, points: 7700, free: [reward(67240272, 1, 2), reward(67240272, 1, 1)], premium: [reward(67240104, 6, 1), reward(67240104, 6, 1)] },
  { level: 23, points: 8800, free: [reward(67240177, 2, 1), reward(67240177, 1, 1)], premium: [reward(67240164, 0, 1), reward(67240165, 0, 1)] },
  { level: 24, points: 10000, free: [reward(67239971, 3, 1), reward(67239974, 2, 1)], premium: [reward(67240213, 0, 8), reward(67240213, 0, 8)] },
  { level: 25, points: 12500, free: [reward(67240277, 0, 5), reward(67240277, 0, 5)], premium: [reward(67240280, 0, 10), reward(67240280, 0, 10)] },
];

export const ALLIANCE_BOUNTY_PREMIUM_PREVIEW = [
  reward(67240280, 0, 20),
  reward(67240213, 0, 16),
  reward(67240164, 0, 1),
  reward(67240165, 0, 1),
  reward(67240104, 6, 2),
  reward(67240098, 6, 2),
  reward(67698721, 0, 10),
  reward(67240276, 0, 30),
  reward(67240278, 0, 20),
  reward(67240388, 0, 8),
  reward(67240181, 0, 4),
  reward(67240022, 3, 4),
];

export const ALLIANCE_BOUNTY_RANKING_REWARDS = [
  { id: 1, from: 1, to: 1, rewards: [reward(67567638, 3, 1), reward(68026387, 3, 1), reward(67240216, 0, 25), reward(67240205, 2, 2), reward(67240142, 3, 35)] },
  { id: 2, from: 2, to: 2, rewards: [reward(67567638, 2, 1), reward(68026387, 2, 1), reward(67240216, 0, 25), reward(67240205, 1, 3), reward(67240142, 3, 30)] },
  { id: 3, from: 3, to: 3, rewards: [reward(67567638, 2, 1), reward(68026387, 2, 1), reward(67240216, 0, 20), reward(67240205, 1, 3), reward(67240142, 3, 30)] },
  { id: 4, from: 4, to: 4, rewards: [reward(67567638, 2, 1), reward(68026387, 2, 1), reward(67240216, 0, 20), reward(67240205, 1, 3), reward(67240142, 3, 25)] },
  { id: 5, from: 5, to: 5, rewards: [reward(67567638, 1, 1), reward(68026387, 1, 1), reward(67240216, 0, 20), reward(67240205, 1, 3), reward(67240142, 3, 25)] },
  { id: 6, from: 6, to: 10, rewards: [reward(67567638, 1, 1), reward(68026387, 1, 1), reward(67240216, 0, 15), reward(67240205, 1, 2), reward(67240142, 3, 25)] },
  { id: 7, from: 11, to: 20, rewards: [reward(67567638, 1, 1), reward(68026387, 1, 1), reward(67240216, 0, 10), reward(67240205, 1, 1), reward(67240142, 3, 20)] },
  { id: 8, from: 21, to: 30, rewards: [reward(67567638, 0, 1), reward(68026387, 0, 1), reward(67240216, 0, 10), reward(67240205, 1, 1), reward(67240142, 3, 20)] },
  { id: 9, from: 31, to: 40, rewards: [reward(67567638, 0, 1), reward(68026387, 0, 1), reward(67240216, 0, 10), reward(67240205, 0, 4), reward(67240142, 3, 15)] },
  { id: 10, from: 41, to: 50, rewards: [reward(67567638, 0, 1), reward(68026387, 0, 1), reward(67240216, 0, 5), reward(67240205, 0, 3), reward(67240142, 3, 10)] },
];

export const SPENDING_EVENT_CONFIGS = [
  {
    id: "rescue-alisa",
    name: "Rescue Alisa",
    type: "currency-ladder",
    currencyLabel: "Cookie",
    currencyItemGid: 67502338,
    notes: [
      { label: "Planner assumption", value: "Bonus rewards are included." },
      { label: "Bonus unlock", value: "199 gold." },
    ],
    cookiePacks: COOKIE_PACKS,
    levels: RESCUE_ALISA_LEVELS,
    feedRewardPools: FEED_REWARD_POOLS,
  },
  {
    id: "road-of-legends",
    name: "Road of Legends",
    type: "battle-pass",
    variantsLabel: "Month",
    variants: ROAD_OF_LEGENDS_MONTHS,
    notes: [
      { label: "Planner assumption", value: "Free and premium tracks are shown together." },
      { label: "Premium unlock", value: "$9.99." },
    ],
  },
  {
    id: "joyful-marble",
    name: "Joyful Marble",
    type: "complex-event",
    notes: [
      { label: "Event currency", value: "Marbles are dropped to earn score and rewards." },
      { label: "Exchange currency", value: "Medals are spent in the exchange store." },
    ],
    marblePacks: JOYFUL_MARBLE_PACKS,
    dailyTasks: JOYFUL_MARBLE_DAILY_TASKS,
    dropSlots: JOYFUL_MARBLE_DROP_SLOTS,
    dropRewards: JOYFUL_MARBLE_DROP_REWARDS,
    scoreMilestones: JOYFUL_MARBLE_SCORE_MILESTONES,
    pointMilestones: JOYFUL_MARBLE_POINT_MILESTONES,
    exchangeStore: JOYFUL_MARBLE_EXCHANGE_STORE,
    handbook: JOYFUL_MARBLE_HANDBOOK,
    handbookGuaranteedThresholds: JOYFUL_MARBLE_HANDBOOK_GUARANTEED_THRESHOLDS,
    handbookGuaranteedPool: JOYFUL_MARBLE_HANDBOOK_GUARANTEED_POOL,
    rankingRewards: JOYFUL_MARBLE_RANKING_REWARDS,
  },
  {
    id: "toy-adventure",
    name: "Toy Adventure",
    type: "complex-event",
    notes: [
      { label: "Hit cost", value: "10 Inflated Hammers per hit." },
      { label: "Normal bear", value: "1,000 HP." },
      { label: "Special mechanics", value: "Rampage Bear and Lucky Time can appear during hits." },
    ],
    specialLadderTitle: "Toy Shop Ladder",
    specialLadderDescription: "Free ladder rewards, hammer bundles, and larger prize steps.",
    specialLadder: TOY_ADVENTURE_GIFT_LADDER,
    bossRewardTitle: "Bear Rewards",
    bossRewards: TOY_ADVENTURE_BOSS_REWARDS,
    dailyScoreRewards: TOY_ADVENTURE_DAILY_SCORE_REWARDS,
    rankingRewards: TOY_ADVENTURE_RANKING_REWARDS,
  },
  {
    id: "starlight-ceremony",
    name: "Starlight Ceremony",
    type: "complex-event",
    currencyLabel: "Starlight Coin",
    notes: [
      { label: "Event loop", value: "Buy Starlight Coins, send gifts, and earn charm score." },
      { label: "Rankings", value: "Separate reward tables exist for sending gifts and receiving charm." },
      { label: "Level costs", value: "Known level costs are shown; unknown levels stay blank." },
    ],
    currencyPackTitle: "Starlight Coin Packs",
    currencyPackDescription: "Coin packs from the event store.",
    currencyPacks: STARLIGHT_CEREMONY_PACKS,
    spendMilestoneTitle: "Level Rewards",
    spendMilestoneDescription: "Known cumulative XP, efficient pack plan, and rewards by level.",
    spendMilestoneMode: "partial-currency-ladder",
    spendMilestoneUnit: "XP",
    spendMilestones: STARLIGHT_CEREMONY_PURCHASE_MILESTONES,
    giftItemsTitle: "Gift Shop",
    giftItemsDescription: "Gift currency cost and charm value.",
    giftItems: STARLIGHT_CEREMONY_GIFTS,
    rankingRewardGroups: [
      { id: "send", label: "Gift Sending Ranking", rows: STARLIGHT_CEREMONY_SEND_RANK_REWARDS },
      { id: "charm", label: "Charm Ranking", rows: STARLIGHT_CEREMONY_CHARM_RANK_REWARDS },
    ],
  },
  {
    id: "group-buying-star",
    name: "Group Buying Star",
    type: "complex-event",
    notes: [
      { label: "Event loop", value: "Alliance and nation group spend unlocks better purchase prices." },
      { label: "Event data", value: "Discount thresholds, milestone rewards, and reward pools are shown." },
    ],
    discountLadders: GROUP_BUYING_STAR_DISCOUNTS,
    spendMilestoneTitle: "Group Spend Rewards",
    spendMilestoneDescription: "Milestone rewards unlocked by cumulative group spend.",
    spendMilestones: GROUP_BUYING_STAR_MILESTONES,
    rewardPools: GROUP_BUYING_STAR_REWARD_POOL,
  },
  {
    id: "alliance-bounty",
    name: "Alliance Bounty",
    type: "complex-event",
    notes: [
      { label: "Event loop", value: "Complete bounty cards to earn individual points and unlock ladder rewards." },
      { label: "Premium track", value: "Free and premium ladder rewards are shown separately." },
      { label: "Bounty board", value: "The bounty list shows the available bounty cards." },
    ],
    bountyTasksTitle: "Bounty Board",
    bountyTasksDescription: "Bounty cards, star level, requirement, and point value.",
    bountyTasks: ALLIANCE_BOUNTY_TASKS,
    bountyLadderTitle: "Individual Points Ladder",
    bountyLadderDescription: "Cumulative points required for free and premium reward tracks.",
    bountyLadder: ALLIANCE_BOUNTY_LADDER,
    premiumShowcaseTitle: "Premium Track Preview",
    premiumShowcase: ALLIANCE_BOUNTY_PREMIUM_PREVIEW,
    rankingRewardGroups: [
      { id: "alliance", label: "Alliance Ranking Rewards", rows: ALLIANCE_BOUNTY_RANKING_REWARDS },
    ],
  },
  {
    id: "brutal-drag-racing",
    name: "Brutal Drag Racing",
    type: "complex-event",
    notes: [
      { label: "Event loop", value: "Upgrade the drag racer, race for score, and claim level rewards." },
      { label: "Pack reset", value: "Planner assumes XP packs reset daily for all 5 days." },
    ],
    eventDays: 5,
    spendMilestoneMode: "currency-ladder",
    spendMilestoneUnit: "XP",
    currencyLabel: "Drag Racing XP",
    currencyPacks: BRUTAL_DRAG_RACING_XP_PACKS,
    showCurrencyPacks: false,
    spendMilestoneTitle: "Car Level Rewards",
    spendMilestoneDescription: "Milestone rewards with required XP and the lowest-cost pack plan.",
    spendMilestones: BRUTAL_DRAG_RACING_REWARD_MILESTONES,
  },
];
